"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Heading = require("./Heading.styles");

var Heading = function Heading(_ref) {
  var centered = _ref.centered,
      className = _ref.className,
      element = _ref.element,
      headline = _ref.headline,
      suffix = _ref.suffix,
      text = _ref.text,
      type = _ref.type;
  return /*#__PURE__*/_react["default"].createElement(_Heading.StyledHeading, {
    as: element,
    centered: centered,
    className: className,
    role: "presentation",
    type: type
  }, /*#__PURE__*/_react["default"].createElement(_Heading.StyledHeadingText, {
    headline: headline,
    type: type
  }, /*#__PURE__*/_react["default"].createElement("span", null, text), suffix && /*#__PURE__*/_react["default"].createElement(_Heading.StyledSuffix, null, suffix)));
};

Heading.defaultProps = {
  centered: false,
  className: null,
  element: 'h1',
  headline: 'off',
  suffix: undefined,
  type: 'primary'
};
Heading.propTypes = {
  /** Display a centered heading text */
  centered: _propTypes.bool,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Element that will be used to render the heading */
  element: (0, _propTypes.oneOf)(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),

  /** For instances when larger font-sizes are needed */
  headline: (0, _propTypes.oneOf)(['off', 'subheadline', 'headline']),

  /** Heading suffix. Appended to the text */
  suffix: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** The text of the heading */
  text: _propTypes.string.isRequired,

  /** The type of alert. Possible values: */
  type: (0, _propTypes.oneOf)(['primary', 'secondary', 'tertiary'])
};
Heading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Heading",
  "props": {
    "centered": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Display a centered heading text",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "element": {
      "defaultValue": {
        "value": "'h1'",
        "computed": false
      },
      "description": "Element that will be used to render the heading",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'h1'",
          "computed": false
        }, {
          "value": "'h2'",
          "computed": false
        }, {
          "value": "'h3'",
          "computed": false
        }, {
          "value": "'h4'",
          "computed": false
        }, {
          "value": "'h5'",
          "computed": false
        }, {
          "value": "'h6'",
          "computed": false
        }]
      },
      "required": false
    },
    "headline": {
      "defaultValue": {
        "value": "'off'",
        "computed": false
      },
      "description": "For instances when larger font-sizes are needed",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'off'",
          "computed": false
        }, {
          "value": "'subheadline'",
          "computed": false
        }, {
          "value": "'headline'",
          "computed": false
        }]
      },
      "required": false
    },
    "suffix": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Heading suffix. Appended to the text",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "The type of alert. Possible values:",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }]
      },
      "required": false
    },
    "text": {
      "description": "The text of the heading",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Heading;
exports["default"] = _default;